import { BrowserRouter, Route, Routes } from "react-router";
import { lazy, Suspense } from "react";

import MainLayout from "../components/layouts/MainLayout";
import DashboardLayout from "../components/layouts/DashboardLayout";
import ProtectedRoute from "./ProtectedRoute";
import LoadingSpinner from "../components/ui/loading spinner/LoadingSpinner";
import MainSpinner from "../components/ui/main spinner/MainSpinner";

const HomePage = lazy(() => import("../features/portfolio/home/HomePage"));
const NewsPage = lazy(() => import("../features/portfolio/news/NewsPage"));
const ReferencesPage = lazy(
  () => import("../features/portfolio/references/ReferencesPage"),
);
const ServicesPage = lazy(
  () => import("../features/portfolio/services/ServicesPage"),
);
const PartnersPage = lazy(
  () => import("../features/portfolio/partners/PartnersPage"),
);
const AboutPage = lazy(() => import("../features/portfolio/about/AboutPage"));
const ProductsPage = lazy(
  () => import("../features/portfolio/products/ProductsPage"),
);
const ContactUsPage = lazy(
  () => import("../features/portfolio/contact/ContactUsPage"),
);

const LoginPage = lazy(() => import("../features/auth/LoginPage"));

// Dashboard pages
const ManageNews = lazy(
  () => import("../features/dashboard/manageNews/ManageNews"),
);
const ManageReferences = lazy(
  () => import("../features/dashboard/manageReferences/ManageReferences"),
);
const ManageServices = lazy(
  () => import("../features/dashboard/manageServices/ManageServices"),
);
const ManagePartners = lazy(
  () => import("../features/dashboard/managePartners/ManagePartners"),
);
const ManageProducts = lazy(
  () => import("../features/dashboard/manageProducts/ManageProducts"),
);

function RoutesList() {
  return (
    <BrowserRouter>
      <Suspense fallback={<MainSpinner/>}>
        <Routes>
          {/* Portfolio pages */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="reference" element={<ReferencesPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="contact" element={<ContactUsPage />} />
          </Route>

          {/* Login page */}
          <Route path="/login" element={<LoginPage />} />

          {/* Dashboard pages */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="news" element={<ManageNews />} />
            <Route path="references" element={<ManageReferences />} />
            <Route path="services" element={<ManageServices />} />
            <Route path="partners" element={<ManagePartners />} />
            <Route path="products" element={<ManageProducts />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default RoutesList;
